class Subscription {
  constructor(subject, observer) {
    this.subject = subject;
    this.observer = observer;
  }

  unsubscribe() {
    this.subject.unsubscribe(this.observer);
    this.subject = null;
  }
}

export default class Subject {
  observers = [];

  subscribe(observer) {
    this.observers.push(observer);
    return new Subscription(this, observer);
  }

  unsubscribe(observer) {
    const observerIndex = this.observers.indexOf(observer);
    if (observerIndex !== -1) {
      this.observers.splice(observerIndex, 1);
    }
  }

  next(...payload) {
    this.observers.forEach((observer) => {
      observer.next(...payload);
    });
  }
}
